<ion-header>
  <ion-toolbar color="light">
    <ion-button fill="clear" slot="start">
      <ion-title>
        {{ 'changeExamComponent.placeInExamComponent' | translate }}
      </ion-title>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p class="ion-padding-horizontal">
    {{
      'changeExamComponent.placeCourseInFollowingComponent'
        | translate: { courseCode: course.code, courseName: getCourseName() }
    }}
  </p>
  <ion-list lines="none">
    <ion-item>
      <ion-radio-group [value]="currentlyChosen?.uniqueId" (ionChange)="handleChange($event)">
        @for (examComponentToChoose of examComponentsToChooseFrom; track examComponentToChoose.uniqueId) {
          @if (!isLockedProposalComponent(examComponentToChoose)) {
            <ion-radio
              [value]="examComponentToChoose.uniqueId"
              labelPlacement="end"
              justify="start"
              [disabled]="isLockedProposalComponent(examComponentToChoose)"
              [ngClass]="{ 'exam-component-other': isExamComponentOther(examComponentToChoose) }"
            >
              {{ examComponentToChoose.examComponentName }}
              @if (examComponentToChoose.specialisationName || examComponentToChoose.minorName) {
                ({{ examComponentToChoose.specialisationName || examComponentToChoose.minorName }})
              }
            </ion-radio>
          }
        }
      </ion-radio-group>
    </ion-item>
  </ion-list>

  @if (getLockedProposalExplanation()) {
    <div class="locked-proposal-text ion-padding-horizontal">
      {{ getLockedProposalExplanation() }}
    </div>
  }
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding-horizontal">
    <ion-button class="confirm-cancel" (click)="cancel()" fill="clear" color="primary" slot="start">
      {{ 'label.cancel' | translate }}
    </ion-button>
    <ion-button class="confirm-button" (click)="confirm()" fill="solid" color="success" slot="end">
      {{ 'label.ok' | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
